import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { openCurrentYear } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';
import { showErrorSnackbar } from 'components/shared/Snackbar';

export const useOpenYear = () => {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();
  return useMutation(openCurrentYear, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['yearClosure', 'list']
      });
      showSnackbar({
        severity: 'success',
        message: t('yearClosure.year_open_success')
      });
    },
    onError: () => showErrorSnackbar()
  });
};
